import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../../utils';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  label?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, label, id, ...props }, ref) => {
    const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={textareaId} className="block text-sm font-medium text-text-secondary mb-1.5">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={cn(
            'w-full min-h-[80px] px-3 py-2 bg-[var(--field-bg)]',
            'border border-border rounded-md',
            'text-text-primary placeholder-text-placeholder',
            'focus:outline-none focus:border-[color:var(--ring-color)] focus:ring-1 focus:ring-border',
            'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-surface-2',
            'transition-colors resize-y',
            error && 'border-error-500 focus:ring-error-500',
            className
          )}
          aria-invalid={!!error}
          aria-describedby={error ? `${textareaId}-error` : undefined}
          {...props}
        />
        {error && (
          <p id={`${textareaId}-error`} className="mt-1.5 text-sm text-error-600">
            {error}
          </p>
        )}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';
